<template>
  <div
    :class="[
      'absolute z-10 left-0 top-header-main-desktop mobile+tablet:hidden w-full h-screen transform',
    ]"
  >
    <div
      :class="['z--1 absolute inset-0 bg-grey-800 opacity-70 cursor-pointer']"
      @click="closeDesktopMegamenu(true)"
    ></div>

    <div
      :class="['absolute z-10 top-0 left-0 bg-white pt-4 pb-22.5 w-full']"
      @mouseover="openDesktopMegamenu(navItem.id)"
      @mouseleave="closeDesktopMegamenu(false)"
    >
      <div class="o-wrapper">
        <div
          :class="['text-md leading-base content mb-4 text-heading font-bold']"
          v-html="navItem.heading"
          v-if="navItem.heading"
        ></div>

        <div class="flex">
          <div class="w-full">
            <MegamenuTwoStepBox :type="type" :navItems="mainChildren" />
          </div>

          <div class="min-w-[408px]">
            <NavPostcodeBox
              :type="type"
              :navItems="sideLinks"
              :communities="communities"
              :nearbyRedirectUrl="nearbyRedirectUrl"
              :enquireUrl="enquireUrl"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MegamenuTwoStepBox from './MegamenuTwoStepBox';
import NavPostcodeBox from './NavPostcodeBox';
import { COMMUNITY_TYPE, HOMES_TYPE } from '../../../configs/type';

export default {
  components: {
    MegamenuTwoStepBox,
    NavPostcodeBox,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return [COMMUNITY_TYPE, HOMES_TYPE].includes(value);
      },
    },
    navItem: {
      type: Object,
      required: true,
    },
    communities: {
      type: Array,
      required: true,
    },
    closeDesktopMegamenu: {
      type: Function,
      required: true,
    },
    openDesktopMegamenu: {
      type: Function,
      required: true,
    },
    nearbyRedirectUrl: {
      type: String,
      required: true,
    },
    enquireUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    mainChildren() {
      return this.navItem.children.filter(
        (child) =>
          !child.attributes.groupType ||
          (child.attributes.groupType &&
            child.attributes.groupType !== 'sideLinks')
      );
    },
    sideLinks() {
      const sideLinkGroup = this.navItem.children.find(
        (child) => child.attributes.groupType === 'sideLinks'
      );
      return sideLinkGroup !== undefined ? sideLinkGroup.children : [];
    },
  },
};
</script>
